import React, { Fragment, ReactNode } from "react";

type Props = {
  if: boolean;
  children: ReactNode | ReactNode[];
};

const Show: React.FC<Props> = ({ if: cond, children }) => {
  if (!cond) return null;
  return <Fragment>{children}</Fragment>;
};

export default Show;
